import { Address } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { IFormChangeAddress } from './get-address-initial-values';

export const getOvernightAddress = (values: IFormChangeAddress): Address => {
	let overnightAddress = {
		line1: values.overnightAddress.line1,
		line2: values.overnightAddress.line2 ?? undefined,
		line3: values.overnightAddress.line3 ?? undefined,
		line4: values.overnightAddress.line4 ?? undefined,
		city: values.overnightAddress.city,
		postcode: values.overnightAddress.postcode,
	};
	if (values.overnightAddressIsAway === 'no') {
		overnightAddress = {
			line1: values.address.line1,
			line2: values.address.line2 ?? undefined,
			line3: values.address.line3 ?? undefined,
			line4: values.address.line4 ?? undefined,
			city: values.address.city,
			postcode: values.address.postcode,
		};
	}

	return overnightAddress;
};
